var map = {
	"./AboutUs.vue": [
		"2664",
		"chunk-062e020d"
	],
	"./Admin.vue": [
		"3530",
		"chunk-1b367f30"
	],
	"./BusinessesRegistration.vue": [
		"5f4e",
		"chunk-2b5a0260"
	],
	"./Categories.vue": [
		"58c2",
		"chunk-0004c96d"
	],
	"./Category.vue": [
		"4886",
		"chunk-d5d53226"
	],
	"./CompanyProfile.vue": [
		"8160",
		"chunk-230b40d0"
	],
	"./ContactUs.vue": [
		"e9bb",
		"chunk-7e1269c4"
	],
	"./Course.vue": [
		"9f72",
		"chunk-ac18f48a"
	],
	"./Dashboard.vue": [
		"7277",
		"chunk-7e7db24c"
	],
	"./GVGroup.vue": [
		"ed4c",
		"chunk-590d089a"
	],
	"./GVLearning.vue": [
		"2120",
		"chunk-3c9573b4"
	],
	"./Home.vue": [
		"bb51",
		"chunk-003f2c99"
	],
	"./Lesson.vue": [
		"fa8f",
		"chunk-d03ed0ce"
	],
	"./Login.vue": [
		"a55b",
		"chunk-21d53d76"
	],
	"./MembershipRegistration.vue": [
		"0f9e",
		"chunk-037e622f"
	],
	"./MyCourses.vue": [
		"11c7",
		"chunk-7acdb14b"
	],
	"./Store.vue": [
		"2c25",
		"chunk-6f8536cb"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;